import { AxiosResponse } from "axios";
import {
  ContextResponse,
  TopicItem,
  ContextAIResponse,
} from "./responsePayload/KnowledgeResponse";
import { apiGetRequest, apiDeleteRequest } from "./util/apiUtils";
import { Endpoint } from "./util/contants";

export const GetContext = async (
  endpoint: string | undefined = Endpoint.Context,
  page: number | undefined = undefined
): Promise<ContextResponse | undefined> => {
  return await apiGetRequest<ContextResponse>(
    endpoint,
    { status: 1 },
    {
      page: page,
    }
  );
};

export const DeleteContext = async (
  contextId: number
): Promise<AxiosResponse | null> => {
  return await apiDeleteRequest(Endpoint.ContextDelete, {
    id: contextId,
  });
};

export const GetContextAI = async (
  contextId: number
): Promise<TopicItem[] | undefined> => {
  const res = await apiGetRequest<ContextAIResponse>(Endpoint.ContextAI, {
    id: contextId,
  });
  return res?.topics;
};
